import { UserAddOutlined } from '@ant-design/icons'
import { Button, Card, Empty, Flex, Form } from 'antd'
import { useEffect, useState } from 'react'

import { useIdentityServiceGetProfileRoleListEndpoint } from 'src/api/queries'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { AddRoleModal, RoleCard } from '..'

import { useStyles } from './styles'

type Props = {
  id?: string
}

export const UserRolesCard = ({ id }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const [form] = Form.useForm()

  const [isOpenModal, setIsOpenModal] = useState(false)

  const { data, isLoading } = useIdentityServiceGetProfileRoleListEndpoint({
    id: String(id)
  })

  const onToggle = () => setIsOpenModal((prev) => !prev)

  useEffect(() => {
    if (data) form.setFieldsValue({ roles: data.data })
  }, [data])

  return (
    <>
      <Form form={form} layout="vertical" requiredMark={false}>
        <Card bordered={false} loading={isLoading}>
          <Form.List name="roles">
            {(fields) => (
              <Flex vertical>
                <Flex
                  justify="space-between"
                  align="center"
                  className={styles.heading}
                >
                  <Text size="xxl">{t('users.system_roles')}</Text>

                  <Button icon={<UserAddOutlined />} onClick={onToggle}>
                    {t('users.assignee_role')}
                  </Button>
                </Flex>

                <Flex vertical gap={24}>
                  {!fields.length && (
                    <Empty
                      className={styles.empty}
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={
                        <Text weight={400} size="xl">
                          {t('users.no_roles')}
                        </Text>
                      }
                    />
                  )}

                  {fields.map(({ name, key }) => (
                    <Flex gap={24} key={key}>
                      <RoleCard key={key} name={name} form={form} />
                    </Flex>
                  ))}
                </Flex>
              </Flex>
            )}
          </Form.List>
        </Card>
      </Form>

      {isOpenModal && <AddRoleModal onCancel={onToggle} />}
    </>
  )
}
